import { FileUpload } from "./File";

export class StructuredOperationTypeFileModel {
  structuredOperationAssetId: number = null;
  structuredOperationAssetSubtypeId: number = null;
  typeFileIdList: StructuredOperationAssetTypeFileId[];
}

export class StructuredOperationAssetTypeFileId {
  structuredOperationAssetSubtypeFileId: number = null;
  fileId: number = null;
  file: FileUpload;
}
